import {Component} from "preact";
import {translate} from "../../../../../../services/TranslateService";
import ToolbarButton from "../../../../../common/toolbar-button";
import Account from 'mdi-preact/AccountIcon';
import style from './styles.scss';
import SectionComponent from "../../../../../layout/section-component";
import DropDownMenu from "../../../../../common/dropdown";
import ProfileBox from "../profile-box";
import {OutsideClickWrapper} from "../../../../../layout/outside-click-wrapper";
import ConfigService from "../../../../../../services/ConfigService";
import ProfileMain from "../profile-main";
import ProfileService from "../../../../../../services/ProfileService";
import SimpleBadge from "../../../../../common/simple-badge";
import Text from "../../../../../common/text";
import ClockIcon from "mdi-preact/ClockIcon";

export default class ProfileButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false
        };
    }

    componentDidMount() {
        ProfileService.sessionExpiring.subscribe(this.update);
    }

    componentWillUnmount() {
        ProfileService.sessionExpiring.subscribe(this.update);
    }

    update = () => this.forceUpdate();

    render(props, state, context) {
        const profile = ConfigService.userProfile();
        const hasProfile = Object.keys(profile || {}).length;
        const buttonStyles = this.state.open ? {background: '#0079B8'} : {};

        const unreadBadge = () => ProfileService.sessionExpiring() ? <SimpleBadge class={style.badgeDanger}><ClockIcon /></SimpleBadge> : null;

        const button = () => {
            if (hasProfile) {
                return (
                    <SectionComponent>
                        <div class={style.buttonContainer}>
                            <ToolbarButton type={'text'} onClick={this.toggleDropdown} title={translate('profile.title')}
                                           style={Object.assign({overflow: 'initial'}, buttonStyles)}>
                                <span class={style.profileText}>{profile.username}</span>
                                <Account/>{unreadBadge()}
                            </ToolbarButton>

                            {!ProfileService.sessionExpiring() ? null : (
                                <div className={style.tooltip}>
                                    <Text text={'profile.session_expiration_alert.short'} />
                                </div>
                            )}
                        </div>
                        <DropDownMenu open={this.state.open} closeFunction={this.toggleDropdown}>
                            <ProfileMain/>
                        </DropDownMenu>
                    </SectionComponent>
                );
            }
        };

        return (
            <OutsideClickWrapper watch={this.state.open} onOutsideClick={this.toggleDropdown}>
                {button()}
            </OutsideClickWrapper>
        );
    }

    toggleDropdown = () => {
        if (Object.keys(ConfigService.userProfile()).length) this.setState({open: !this.state.open});
    };
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/user/profile-button/index.js